export { default as FlagOutlineIcon } from './FlagOutlineIcon';
